import Axios from "axios";
import Host from "./host";
import router from "@/router";
import { Toast } from 'vant';

const axios = Axios.create({
  baseURL: Host.host,
  timeout: 10000,
  headers: {
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    // 'X-Requested-With': 'XMLHttpRequest',
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'Accept': 'application/json',
    // 'Content-Type': 'application/json',
    // "Content-Type": "application/x-www-form-urlencoded",
    // 'Authorization': `Bearer ${JWT}`,
    // 'Authorization': `Bear ${JWT}`,
    // 'Referer-token': 'http://entry.custom.24haowan.com/entrances/nfhk5th'
  }
});
// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
    
    config.withCredentials = true
    // console.log(config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    // console.log(response)
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    let errorMsg = ''
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        case 401:
          sessionStorage.removeItem("token")
          router.push({path: "/"});
          setTimeout(() => {
            location.reload()
          }, 200);
          break;
        case 404:
          errorMsg = '网络请求不存在!'
          break;
        case 500:
          errorMsg = '服务器繁忙!'
          break;
        default:
          errorMsg = '服务器繁忙!'
          break;
      }
      if(error.response.status != 401){
        Toast.fail(errorMsg);
      }
      return Promise.reject(error);
    }
  }
);

/**
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post(url, params = {}) {
  params.token = sessionStorage.getItem("token");
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { withCredentials: true })
      .then(v => {
        if (v.data.code == 200) {
          resolve(v.data.data);
        } else {
          reject(v.data);
        }
      })
      .catch(err => {
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/Interface/axios.js